import gql from 'graphql-tag'
export interface UsersInput {
  name?: string | null
}

export interface SelectionOnUsers {
  id: string
  name: string | null
}

export interface Users {
  users: Array<SelectionOnUsers>
}

export default gql`
  query Users($name: String) {
    users(name: $name) {
      id
      name
    }
  }
`



// WEBPACK FOOTER //
// ./src/graphql/queries/usersLean.tsx